import { DateTime } from 'luxon'
const debug = require('debug')('OD::Lib:DateHelper')

const showLogs = false
const shortDateFormat = 'yyyy-MM-dd'
const textDateFormat = 'yyyy-MM-dd HH:mm'
const longDateFormat = 'yyyy-MM-dd HH:mm:ss'
const shortDateRegex = /^\d*-\d*-\d*$/
const textDateRegex = /^\d*-\d*-\d* \d*:\d*$/
const longDateRegex = /^\d*-\d*-\d* \d*:\d*:\d*$/

export default {
  getFisrtWeekDay(year, week) {
    if (showLogs) debug('getFisrtWeekDay', { year, week })
    const result = DateTime.fromObject({
      weekYear: parseInt(year),
      weekNumber: parseInt(week),
      weekday: 1,
    })
    if (showLogs) debug('getFisrtWeekDay return', result)
    return result
  },
  getWeekDates(year, week) {
    if (showLogs) debug('getWeekDates', { year, week })
    const dates = []
    const date = this.getFisrtWeekDay(year, week)
    for (let index = 0; index < 7; index++) {
      dates.push(date.plus({ days: index }).toFormat(shortDateFormat))
    }
    if (showLogs) debug('getWeekDates return', dates)
    return dates
  },
  getWeekSaturday(year, week) {
    if (showLogs) debug('getWeekSaturday', { year, week })
    const result = DateTime.fromObject({
      weekYear: parseInt(year),
      weekNumber: parseInt(week),
      weekday: 6,
    }).toFormat(shortDateFormat)
    if (showLogs) debug('getWeekSaturday return', result)
    return result
  },
  getToday() {
    if (showLogs) debug('getToday')
    const result = DateTime.local()
    if (showLogs) debug('getToday return', result)
    return result
  },
  getDate(stringValue) {
    if (showLogs) debug('getDate', stringValue)
    let result = ''
    if (stringValue.includes('GMT')) {
      if (showLogs) debug('getDate', 'Parse 1', 'GMT')
      result = DateTime.fromHTTP(stringValue)
    } else if (shortDateRegex.test(stringValue)) {
      if (showLogs) debug('getDate', 'Parse 2', 'short')
      result = DateTime.fromFormat(stringValue, shortDateFormat)
    } else if (textDateRegex.test(stringValue)) {
      if (showLogs) debug('getDate', 'Parse 3', 'text')
      result = DateTime.fromFormat(stringValue, textDateFormat)
    } else if (longDateRegex.test(stringValue)) {
      if (showLogs) debug('getDate', 'Parse 4', 'long')
      result = DateTime.fromFormat(stringValue, longDateFormat)
    } else {
      if (showLogs) debug('getDate', 'Parse 5', 'notfound')
      result = DateTime.fromFormat(stringValue, shortDateFormat)
    }
    if (showLogs) debug('getDate return', result)
    return result
  },
  getTodayShortString() {
    if (showLogs) debug('getTodayShortString')
    const result = this.getToday().toFormat(shortDateFormat)
    if (showLogs) debug('getTodayShortString return', result)
    return result
  },
  getTodayLongString() {
    if (showLogs) debug('getTodayLongString')
    const result = this.getToday().toFormat(longDateFormat)
    if (showLogs) debug('getTodayLongString return', result)
    return result
  },
  getDateShortString(stringValue) {
    if (showLogs) debug('getDateShortString', stringValue)
    const result = this.getDate(stringValue).toFormat(shortDateFormat)
    if (showLogs) debug('getDateShortString return', result)
    return result
  },
  getDateTextString(stringValue) {
    const date = this.getDate(stringValue)
      .setLocale('es')
      .toLocaleString(DateTime.DATE_HUGE)
    const hour = this.getDate(stringValue)
      .setLocale('es')
      .toLocaleString(DateTime.TIME_24_SIMPLE)
    const result = `${date} - ${hour}`
    if (showLogs) debug('getDateTextString return', result)
    return result
  },
  getDateFronNowString(stringValue) {
    if (showLogs) debug('getDateFronNowString', stringValue)
    const result = this.getDate(stringValue).setLocale('es')
    // .fromNow()
    debug('PENDING IMPLEMENT fromNow()')
    if (showLogs) debug('getDateFronNowString return', result)
    return result
  },
  getWeekNumber() {
    if (showLogs) debug('getWeekNumber')
    const result = this.getToday().toFormat('W')
    if (showLogs) debug('getWeekNumber return', result)
    return result
  },
  getYearNumber() {
    if (showLogs) debug('getYearNumber')
    const result = this.getToday().toFormat('yyyy')
    if (showLogs) debug('getYearNumber return', result)
    return result
  },
  minTwoDigits(num) {
    return ('0' + num).slice(-2)
  },
  getDatesDiffString(dateIni, dateEnd) {
    if (showLogs) debug('getDatesDiffString', { dateIni, dateEnd })
    const start = this.getDate(dateIni)
    const stop = dateEnd ? this.getDate(dateEnd) : this.getToday()
    const timeDiff = stop.diff(start, ['hours', 'minutes', 'seconds'])
    const hours = this.minTwoDigits(timeDiff.hours)
    const minutes = this.minTwoDigits(timeDiff.minutes)
    const seconds = this.minTwoDigits(Math.trunc(timeDiff.seconds))
    let text = ''
    if (timeDiff.hours > 0) {
      text = `${hours}:${minutes}:${seconds}`
    } else {
      text = `${minutes}:${seconds}`
    }
    if (showLogs) debug('getDatesDiffString return', text)
    return text
  },
  getDatesDiffInSeconds(dateIni, dateEnd) {
    if (showLogs) debug('getDatesDiffInSeconds', { dateIni, dateEnd })
    const start = this.getDate(dateIni)
    const stop = dateEnd ? this.getDate(dateEnd) : this.getToday()
    const timeDiff = stop.diff(start, ['seconds'])
    const totalSeconds = Math.trunc(timeDiff.values.seconds)
    if (showLogs) debug('getDatesDiffInSeconds return', totalSeconds)
    return totalSeconds
  },
}
